import { render, staticRenderFns } from "./templateEventCalendar.vue?vue&type=template&id=c549a540&scoped=true"
import script from "./templateEventCalendar.vue?vue&type=script&lang=js"
export * from "./templateEventCalendar.vue?vue&type=script&lang=js"
import style0 from "./templateEventCalendar.vue?vue&type=style&index=0&id=c549a540&prod&scoped=true&lang=scss"
import style1 from "./templateEventCalendar.vue?vue&type=style&index=1&id=c549a540&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c549a540",
  null
  
)

export default component.exports